// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Mount_mountCard__dFnQE {
  margin-bottom: 20px;
}
.Mount_mountCard__dFnQE .ant-card-head-title {
  font-weight: bold;
}

.Mount_alertBox__zV9Nj {
  margin-bottom: 16px;
}

.Mount_sectionTitle__TCcOv {
  margin-top: 24px;
  margin-bottom: 16px;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/pages/Detail/component/mount/Mount.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;AAEI;EACE,iBAAA;AAAN;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;AAFF","sourcesContent":[".mountCard {\n  margin-bottom: 20px;\n  \n  :global {\n    .ant-card-head-title {\n      font-weight: bold;\n    }\n  }\n}\n\n.alertBox {\n  margin-bottom: 16px;\n}\n\n.sectionTitle {\n  margin-top: 24px;\n  margin-bottom: 16px;\n  font-weight: bold;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mountCard": `Mount_mountCard__dFnQE`,
	"alertBox": `Mount_alertBox__zV9Nj`,
	"sectionTitle": `Mount_sectionTitle__TCcOv`
};
export default ___CSS_LOADER_EXPORT___;
